/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_InvitationsInputs */

const en_page_title_invitations = /** @type {(inputs: Page_Title_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations`)
};

const nl_page_title_invitations = /** @type {(inputs: Page_Title_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingen`)
};

/**
* | output |
* | --- |
* | "Invitations" |
*
* @param {Page_Title_InvitationsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_invitations = /** @type {((inputs?: Page_Title_InvitationsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_InvitationsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_invitations(inputs)
	return en_page_title_invitations(inputs)
});